<template>
  <div class="release">
    <van-uploader
      class="upload-img"
      :after-read="afterRead"
      v-model="fileList"
      accept="image/*, .mp4"
      :preview-size="getPreviewSize"
      max-count="9"
      :max-size="50 * 1024 * 1024"
    />
    <!-- 编辑图片 -->
    <van-action-sheet
      v-model="overlayShow"
      title="图片裁剪"
      cancel-text="完成"
      close-on-click-action
      :closeable="false"
      @cancel="successEdit"
    >
      <div class="wrapper" @click.stop>
        <vueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="option.info"
          :full="option.full"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :fixedBox="option.fixedBox"
        ></vueCropper>
      </div>
    </van-action-sheet>
    <van-cell-group>
      <van-field v-model="title" placeholder="为你的精彩内容起一个好标题吧！" />
      <van-field
        v-model="message"
        autosize
        type="textarea"
        placeholder="输入正文内容"
      />
      <van-field
        v-model="productName"
        center
        clearable
        readonly
        placeholder="关联文中使用的丘比产品"
        @click="showPicker = true"
      >
        <template #button>
          <div class="associated-goods">
            <!-- <span>+10积分</span> -->
            <img src="~assets/img/arrow-right-red.png" alt="" />
          </div>
        </template>
      </van-field>
      <van-cell
        v-for="(item, index) in chooseProducts"
        :key="item.id"
        :title="item.name"
      >
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <van-icon
            name="cross"
            class="product-cross"
            @click="productCrossClick(index)"
          />
        </template>
      </van-cell>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="productNames"
          @confirm="onProductConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field class="keycodes" v-model="keycode" placeholder="添加关键字" />
    </van-cell-group>
    <div v-if="activityKeywords.length > 0" class="join">
      <span>是否要参加：</span>
      <van-checkbox-group v-model="result">
        <van-checkbox
          class="join-item"
          v-for="item in activityKeywords"
          :key="item.id"
          :name="item.id"
          shape="square"
          checked-color="#D33A46"
          >#{{ item.name }}#</van-checkbox
        >
      </van-checkbox-group>
    </div>
    <div class="send" @click="sendContent">修改</div>
  </div>
</template>
<script>
import { getUserUpload } from "network/release";
import { getForums } from "network/home";
import { getProducts, editTopics } from "network/profile";
import qs from "qs";

export default {
  name: "Release",
  components: {},
  data() {
    return {
      postInfo: {},
      title: "",
      message: "",
      keycode: "",
      fileList: [], //选择的文件
      activityKeywords: [],
      result: [], //活动id数组（发布时使用）
      products: [], //产品列表
      productNames: [], //产品名字列表
      chooseProducts: [], //选中的产品列表
      productName: "", //选中的丘比产品个数
      showPicker: false, //选择产品
      //遮罩层
      overlayShow: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        canMove: false, //上传图片是否可以移动
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 100, // 默认生成截图框宽度
        autoCropHeight: 100, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    };
  },
  computed: {
    getPreviewSize() {
      return 107 * (document.body.clientWidth / 375);
    },
  },
  created() {
    //帖子详情
    getForums(this.$route.query.id).then((res) => {
      this.postInfo = res.data;
      this.refreshPage();
    });
    getProducts().then((res) => {
      this.products = res.data;
      this.productNames = res.data.map((item) => {
        return item.name;
      });
    });
  },
  mounted() {},
  methods: {
    //帖子赋值
    refreshPage() {
      this.title = this.postInfo.title;
      this.message = this.postInfo.content;
      this.postInfo.keywords.forEach((item) => {
        // if (item.is_admin === 1) {
        // }
        this.keycode = this.keycode + item.name + " ";
      });
      this.fileList = this.postInfo.media_list;
      this.chooseProducts = this.postInfo.products;
      if (this.chooseProducts.length > 0) {
        this.productName = "已选择（" + this.chooseProducts.length + "）件产品";
      } else {
        this.productName = "";
      }
    },

    //选择完文件的回调
    afterRead(file) {
      console.log(file.file);
      //选择的是图片需要裁剪
      if (file.file.type.indexOf("image") != -1) {
        let url = "";
        var reader = new FileReader();
        reader.readAsDataURL(file.file);
        let that = this;
        reader.onload = function (e) {
          url = this.result.substring(this.result.indexOf(",") + 1);
          that.option.img = "data:image/png;base64," + url;
        };
        this.overlayShow = true;
        this.fileList.pop();
      } else {
        //视频直接上传
        var fileDic = {
          url: "",
          status: "uploading",
          message: "上传中...",
        };
        this.fileList.pop();
        this.fileList.push(fileDic);
        // 此时可以自行将文件上传至服务器
        var post = new FormData();
        post.append("cover_image", file.file);
        getUserUpload(post).then((res) => {
          if (res.error === 0) {
            console.log(res);
            fileDic.url = res.data.file_url;
            fileDic.status = "done";
            fileDic.type = res.data.file_type;
          } else {
            fileDic.status = "failed";
            fileDic.message = "上传失败";
          }
        });
      }
    },
    //编辑图片完成
    successEdit() {
      this.$refs.cropper.getCropBlob((blob) => {
        console.log(blob);
        var fileDic = {
          url: "",
          status: "uploading",
          message: "上传中...",
        };
        this.fileList.push(fileDic);
        // 此时可以自行将文件上传至服务器
        var post = new FormData();
        post.append("cover_image", blob);
        getUserUpload(post).then((res) => {
          if (res.error === 0) {
            console.log(res);
            fileDic.url = res.data.file_url;
            fileDic.status = "done";
            fileDic.type = res.data.file_type;
          } else {
            fileDic.status = "failed";
            fileDic.message = "上传失败";
          }
        });
      });
    },

    //选择最喜欢的产品
    onProductConfirm(value) {
      this.showPicker = false;
      this.products.forEach((item) => {
        if (item.name == value) {
          if (this.chooseProducts.indexOf(item) === -1) {
            this.chooseProducts.push(item);
            this.productName =
              "已选择（" + this.chooseProducts.length + "）件产品";
          }
        }
      });
    },
    //删除选中产品
    productCrossClick(index) {
      this.chooseProducts.splice(index, 1);
      if (this.chooseProducts.length > 0) {
        this.productName = "已选择（" + this.chooseProducts.length + "）件产品";
      } else {
        this.productName = "";
      }
    },

    /**
     * 请求
     */
    sendContent() {
      let product_id_list = [];
      this.chooseProducts.forEach((item) => {
        product_id_list.push(item.id);
      });
      let params = {
        title: this.title,
        content: this.message,
        media_list: JSON.stringify(this.fileList),
        product_id_list: product_id_list,
        keywords: this.keycode,
        keyword_ids: JSON.stringify(this.result),
      };
      editTopics(this.postInfo.id, qs.stringify(params)).then((res) => {
        if (res.data.id > 0) {
          this.$router.push({
            path: "/homepostdefault",
            query: {
              id: res.data.id,
            },
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.release {
  padding-bottom: 55px;
  background: #fff;
}
.upload-img {
  margin: 30px 15px 15px 15px;
}
.associated-goods {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}
.associated-goods img {
  margin-left: 40px;
  width: 20px;
  height: 20px;
}
.associated-goods span {
  color: var(--color-main);
}
.product-cross {
  margin-right: 15px;
  font-size: 16px;
  line-height: inherit;
}
.keycodes {
  margin-top: 15px;
}
.from-buttom {
  padding: 10px 15px;
  font-size: 14px;
  color: #232323;
}
.from-set {
  padding: 10px 15px;
  font-size: 14px;
  color: #232323;
}
.from-set i {
  margin-left: 20px;
  color: var(--color-main);
}
.from-choose {
  padding: 10px 15px;
  font-size: 14px;
  color: rgb(200, 200, 200);
}

.join {
  display: flex;
  margin: 20px 15px;
}
.join-item {
  margin-top: 5px;
  margin-bottom: 5px;
}
::v-deep .van-checkbox__label {
  color: var(--color-main);
}
.send {
  margin: 30px 100px 10px 100px;
  height: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  border-radius: 10px;
  background-color: var(--color-main);
  color: #fff;
}

/* 遮罩层 */
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 500px;
}
</style>

